/* Pawbiotics — Advertorial offer block + sticky CTA
   - Wires the 3 options (no pre-selection)
   - Enables the buy button + updates label/price on selection
   - Handles the "buy one jar" one-time link (POST to /cart/add.js, then redirect)
   - Shows the sticky CTA after the user scrolls past the offer
*/
(function () {
  'use strict';

  const form = document.getElementById('pb-adv-form');
  if (!form) return;

  const radios = form.querySelectorAll('input[name="pb-adv-opt"]');
  const variantInput = document.getElementById('pb-adv-variant-id');
  const planInput = document.getElementById('pb-adv-selling-plan');
  const cta = document.getElementById('pb-adv-cta');
  const ctaLabel = document.getElementById('pb-adv-cta-label');
  const stickyCta = document.getElementById('pb-adv-stickycta');
  const offerSection = document.getElementById('pb-adv-offer');
  const buyOnce = document.getElementById('pb-adv-buy-once');

  function getChecked() {
    return Array.from(radios).find((r) => r.checked);
  }

  function syncSelection() {
    radios.forEach((r) => {
      const card = r.closest('.pb-adv-opt');
      if (!card) return;
      card.classList.toggle('is-selected', r.checked);
    });

    const checked = getChecked();
    if (!checked) {
      if (variantInput) variantInput.value = '';
      if (planInput) planInput.value = '';
      if (cta) cta.disabled = true;
      if (ctaLabel) ctaLabel.textContent = 'Select an option above';
      return;
    }

    if (variantInput) variantInput.value = checked.dataset.variantId || '';
    if (planInput) planInput.value = checked.dataset.sellingPlan || '';

    if (cta) cta.disabled = false;
    if (ctaLabel) {
      const label = checked.dataset.label || 'Add to cart';
      const price = checked.dataset.price || '';
      ctaLabel.innerHTML =
        label +
        (price
          ? ' <span class="pb-adv-cta__price">' +
            price +
            (checked.dataset.compare
              ? ' <span class="pb-adv-cta__strike">' + checked.dataset.compare + '</span>'
              : '') +
            '</span>'
          : '');
    }
  }

  radios.forEach((r) => r.addEventListener('change', syncSelection));
  syncSelection();

  /* One-time link: add v30 to cart with no selling plan, open cart */
  if (buyOnce) {
    buyOnce.addEventListener('click', async function (e) {
      e.preventDefault();
      if (buyOnce.classList.contains('is-adding')) return;
      if (!buyOnce.dataset.variantId) {
        window.location.href = '/products/pawbiotic-gut-rescue';
        return;
      }
      buyOnce.classList.add('is-adding');
      try {
        const fd = new FormData();
        fd.append('id', buyOnce.dataset.variantId);
        fd.append('quantity', '1');
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: fd,
        });
        if (!res.ok) throw new Error('add failed');
        window.location.href = '/cart';
      } catch (err) {
        window.location.href = '/cart';
      } finally {
        buyOnce.classList.remove('is-adding');
      }
    });
  }

  /* Sticky CTA: show after the user scrolls past 40% of the page,
     hide once the offer section is in view (so it does not duplicate). */
  if (stickyCta && offerSection) {
    let offerVisible = false;
    const offerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          offerVisible = entry.isIntersecting;
          updateSticky();
        });
      },
      { threshold: 0.05 }
    );
    offerObserver.observe(offerSection);

    function updateSticky() {
      const scrolled = window.scrollY / Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      const shouldShow = scrolled > 0.18 && !offerVisible;
      stickyCta.classList.toggle('is-visible', shouldShow);
    }

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();
  }
})();
